var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showContext)?_c('div',{style:(_vm.menuStyle)},[_c('ul',{staticClass:"list-unstyled"},_vm._l((_vm.contextItems),function(item){return _c('li',{key:item.title,on:{"click":function($event){_vm.click(item.title)}}},[_c('span',[_c('i',{class:item.icon})]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.title))])])}))]):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12b157c7","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/VContext/VContext.vue
// module id = 18
// module chunks = 0